export const ErrorRenderer=_ref=>{let{error:error}=_ref;throw error};ErrorRenderer.displayName="ErrorRenderer";